import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Building2, UserRound, ChevronRight } from "lucide-react";
import AuthShell from "./AuthShell";

// First step of "Create an account": how is this person joining?
const Choice = ({ icon: Icon, title, text, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="w-full flex items-center gap-4 p-4 text-left bg-white border border-[#E3D6B6] rounded-[16px] transition-all hover:border-[#1C1A14] hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-[#1C1A14]/20"
  >
    <span className="h-11 w-11 shrink-0 flex items-center justify-center rounded-[12px] bg-[#FFC81E] text-[#1C1A14]">
      <Icon size={22} />
    </span>
    <span className="flex-1 min-w-0">
      <span className="block font-semibold text-gray-900">{title}</span>
      <span className="block text-sm text-gray-600">{text}</span>
    </span>
    <ChevronRight size={18} className="text-gray-400 shrink-0" />
  </button>
);

const GetStarted = () => {
  const navigate = useNavigate();

  return (
    <AuthShell
      title="Create an account"
      subtitle="How are you joining?"
      onBack={() => navigate("/login")}
    >
      <div className="space-y-3">
        <Choice
          icon={Building2}
          title="I'm setting up my company"
          text="Register your company and become its admin."
          onClick={() => navigate("/signup")}
        />
        <Choice
          icon={UserRound}
          title="I'm joining as an employee"
          text="Your company already uses, or will use, Clock-out."
          onClick={() => navigate("/join")}
        />
      </div>

      <p className="mt-6 text-sm text-center text-gray-600">
        Already have an account?{" "}
        <Link to="/login" className="font-medium text-[#1C1A14] hover:text-[#0f0e0a]">
          Sign in
        </Link>
      </p>
    </AuthShell>
  );
};

export default GetStarted;